export const RETURN_CODE = {
  OK: "OK",
  ERROR: "ERROR",
  ACCOUNT_DOES_NOT_EXIST: "ACCOUNT_DOES_NOT_EXIST",
  DUPLICATE_USER_ID: "DUPLICATE_USER_ID",
  DUPLICATE_USER_EMAIL: "DUPLICATE_USER_EMAIL",
  DUPLICATE_USER_PHONE: "DUPLICATE_USER_PHONE",
  PAYMENT_ERROR: "PAYMENT_ERROR",
  OUT_OF_STOCK: "OUT_OF_STOCK",
  ACCESS_DENY: "ACCESS_DENY",
}

